// eslint-disable-next-line no-restricted-imports
import {useSelector} from 'react-redux';

export function useCountry(options: {institutionId: string}): string {
    return useSelector(state => (state as any).entities.institutions.get(options.institutionId).country);
}
